import { RECEIVING_PO_REASON_DATA } from '../actions/actionType'

const initialState = {
  receivingPOReasonList: [],
}
export default function ReceivingPOReasonsReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVING_PO_REASON_DATA:
      return { ...state, receivingPOReasonList: action.payload }
    default:
      return state
  }
}
